import { memo } from 'react'
import { Carousel as CarouselComponent } from './carousel'

export const Carousel = memo(CarouselComponent)
